module.exports = __webpack_public_path__ + "img/Menu-08.ee055d36.webp";